import { render, staticRenderFns } from "./tareasRecibidas.vue?vue&type=template&id=426f9a7a"
import script from "./tareasRecibidas.vue?vue&type=script&lang=js"
export * from "./tareasRecibidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports